import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { NotProvisionedEmptyState } from 'ui/illustrations';
import { EMPTY_STATE_VARIANTS } from 'ui/emptyState/EmptyState.types';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { iterableLoveText } from '../../../utils';
import { useMetadata } from '../../../hooks';
import { ContinueWithFacebookButton } from './ContinueWithFacebookButton';

export const Ul = styled.ul`
  list-style-type: disc;
  padding-inline-start: ${pxToRem(16)};
  margin-bottom: ${spacing.base};
`;

export const SubtitleContainer = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  text-align: left;
  max-width: ${pxToRem(420)};
`;

export const WhatsAppAccountsEmptyState = ({
  sendingPlatform,
}: {
  sendingPlatform: SendingPlatform;
}) => {
  const { name } = useMetadata(sendingPlatform);
  return (
    <div>
      <EmptyState
        Illustration={() => <NotProvisionedEmptyState height={256} width={256} />}
        title={iterableLoveText(name)}
        variant={EMPTY_STATE_VARIANTS.ILLUSTRATION_TWO_COL}
        subtitle={
          <SubtitleContainer>
            <div>To get started you’ll need a few things:</div>
            <Ul>
              <li> Facebook login information linked to your Meta Business account</li>{' '}
              <li>
                A WhatsApp Business account name, profile & number (or you can create these during
                setup if you don’t have them)
              </li>
            </Ul>
            <ContinueWithFacebookButton />
          </SubtitleContainer>
        }
      />
    </div>
  );
};
